import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import axios from 'axios'
import Moment from 'react-moment'
import Loader from '../../common/Loader'
import CustomFooter from '../../common/TableBottom'

class CurrentBooking extends React.Component {
  state = {
    users_data: [],
    userdata: [],
    open: false,
    limit: 10,
    pageNumber: 0,
    disabled: false,
    keyword: '',
  }

  debounceTimeout = null

  componentDidMount() {
    this.getCurrentBookingList(this.state.limit, this.state.pageNumber, this.state.keyword)
  }

  getCurrentBookingList = async (l, p, search = '') => {
    this.setState({
      open: true,
    })
    var that = this
    await axios
      .get(Constant.getAPI() + `/admin/list-current-bookings?limit=${l}&pageNumber=${p}&keyword=${search}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            Booking_data: res.data.data,
            open: false,
            disabled: !res.data.data?.length > 0,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        this.setState({
          open: false,
        })
      })
  }

  cancelBooking = async (id) => {
    var data = {
      booking_id: id,
    }

    Swal.fire({
      title: 'Are you sure to Cancel Booking?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(Constant.getAPI() + '/booking/cancel-booking', data, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          })
          .then((res) => {
            if (res.status === 200) {
              Swal.fire('Cancelled !', 'Booking Cancelled', 'success')
              this.getCurrentBookingList()
            }
          })
          .catch((err) => {
            this.setState({ isData: false })
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }
  isDisplay = () => {
    if (localStorage?.getItem('loged_In_role') == 'vendor') return false
    else return true
  }

  onSearch = (event) => {
    this.setState(
      {
        keyword: event.target.value,
        pageNumber: 0,
      },
      () => {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

        this.debounceTimeout = setTimeout(() => {
          this.getCurrentBookingList(this.state.limit, this.state.pageNumber, this.state.keyword)
        }, 500)
      }
    )
  }

  clearSearch = () => {
    this.setState(
      {
        keyword: '',
        pageNumber: 0,
      },
      () => {
        this.getCurrentBookingList(this.state.limit, this.state.pageNumber, this.state.keyword)
      }
    )
  }

  render() {
    const customSearchRender = (searchText, handleSearch, hideSearch) => {
      return (
        <div className="container">
          <div className="d-flex justify-content-around">
            <i className="f-16 icofont icofont-search m-t-10 m-r-10"></i>
            <input
              type="search"
              className="form-control custom-input-search"
              placeholder="Search Order number"
              value={this.state.keyword}
              name="keyword"
              onChange={this.onSearch}
            />
            <span
              className="pointer m-t-5"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.clearSearch(hideSearch)
              }}
            >
              <i className="f-24 icofont icofont-close m-l-10"></i>
            </span>
          </div>
        </div>
      )
    }

    const columns = [
      {
        name: 'order_number',
        label: 'Order NO',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'cruise_name_en',
        label: 'CruiseName: English',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'cruise_name_ar',
        label: 'CruiseName: Arabic',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'captain_name',
        label: 'Captain Name',
        options: {
          filter: true,
          sort: true,
          display: localStorage.getItem('loged_In_role') === 'store' ? false : true,
        },
      },
      {
        name: 'total_booking_amount',
        label: 'Total BookingAmount',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'booking_date',
        label: 'Booking Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <div style={{ width: 80 }}>{value}</div>
          },
        },
      },
      {
        name: 'confirmed_booking_date',
        label: 'Confirmed Booking Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (orderPlacedDate) => {
            return (
              <div>
                <Moment format="DD/MM/YYYY">{orderPlacedDate}</Moment>
              </div>
            )
          },
        },
      },
      {
        name: 'booking_status',
        label: 'Booking Status',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'comments',
        label: 'Comments',
        options: {
          filter: true,
          sort: true,
        },
      },
      // {
      //   name: "payment_status",
      //   label: "Payment status",
      //   options: {
      //     filter: true,
      //     sort: true,
      //     customBodyRender: (payment_status, tableMeta) => {
      //       return (
      //         <div>
      //           {payment_status === true ? <span className="badge badge-pill badge-success">Success</span> :
      //             <span className="badge badge-pill badge-warning">In Progress</span>}
      //         </div>

      //       );
      //     },
      //   },
      // },
      //   {
      //     name: "id",
      //     label: "Invoice",
      //     options: {
      //       filter: true,
      //       sort: true,
      //       customBodyRender: (id, tableMeta) => {
      //         return (
      //           <div>
      //             <Link to={"/booking/" + id}>
      //               <span className="pointer" style={{ cursor: "pointer" }}>
      //                 <i className="f-22 icofont icofont-download text-dark"></i>
      //               </span>
      //             </Link>
      //           </div>
      //         );
      //       },
      //     },
      //   },
      // {
      //   name: "bookID",
      //   label: "Additional",
      //   options: {
      //     filter: true,
      //     sort: true,
      //     customBodyRender: (bookID, tableMeta) => {
      //       return (
      //         <div>
      //           <Link
      //             to={"/books-additional/" + bookID}
      //             className="m-r-15 text-muted"
      //             data-toggle="tooltip"
      //             data-placement="top"
      //             title=""
      //             data-original-title="Additional"
      //           >
      //             <i className="f-22 icofont icofont-box text-dark"></i>
      //           </Link>
      //         </div>
      //       );
      //     },
      //   },
      // },
      //   {
      //     name: "id",
      //     label: "Action",
      //     options: {
      //       filter: true,
      //       sort: true,
      //       customBodyRender: (booking_id, tableMeta) => {
      //         return (
      //           <div>
      //             <Link
      //               to={"/bookdetails/" + booking_id}
      //               className="m-r-15 text-muted"
      //               data-toggle="tooltip"
      //               data-placement="top"
      //               title=""
      //               data-original-title="View "
      //             >
      //               <i className="f-22 icofont icofont-eye text-dark"></i>
      //             </Link>
      //           </div>
      //         );
      //       },
      //     },
      //   },
      //   {
      //     name: "id",
      //     label: "Cancel Booking",
      //     options: {
      //       filter: true,
      //       sort: true,
      //       display: this?.isDisplay(),
      //       customBodyRender: (id, tableMeta) => {
      //         return (
      //           <div>
      //             <span className="pointer" style={{ cursor: "pointer" }}
      //               onClick={this.cancelBooking.bind(this, id)}
      //             >
      //               <i className="f-22 icofont icofont-delete"></i>
      //             </span>
      //           </div>
      //         );
      //       },
      //     },
      //   },
    ]
    const options = {
      // filterType: "dropdown",
      viewColumns: false,
      print: false,
      download: true,
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState({
          pageNumber: currentPage,
        })
        this.getCurrentBookingList(this.state.limit, currentPage)
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState({
          limit: numberOfRows,
        })
        this.getCurrentBookingList(numberOfRows, this.state.pageNumber)
      },
      customSearchRender: customSearchRender,
      onSearchClose: () => {
        this.clearSearch()
      },
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.open ? <Loader open={this.state.open} /> : 'Sorry, No Booking Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Current Booking List</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Current Booking List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Current Booking List'}
                          className="table-responsive"
                          data={this.state.Booking_data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CurrentBooking
